var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.722,
    height: 178.385,
    viewBox: "0 0 183.722 178.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_716",
    "data-name": "Grupo 716",
    transform: "translate(4 0.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_346",
    "data-name": "Grupo 346",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_326",
    "data-name": "Grupo 326",
    transform: "translate(-4 8.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_325",
    "data-name": "Grupo 325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2222",
    "data-name": "Caminho 2222",
    d: "M231.245,226.549l-20.14-75.175-1.159-4.317-1.819-6.8-1.159-4.317-1.819-6.795-1.16-4.317-3.465-12.943a16.2,16.2,0,0,0-1.431-3.571A16.036,16.036,0,0,0,195.671,104a16.233,16.233,0,0,0-15.077-3.619L167.09,104l-16.107,4.316-29.913,8.017-5.42,1.455-13.492,3.614a16.273,16.273,0,0,0-11.507,19.93L114.5,230.33l6.875,25.658A16.279,16.279,0,0,0,141.3,267.5l13.5-3.619,16.107-4.317,48.826-13.085A16.294,16.294,0,0,0,231.245,226.549ZM102.718,138.357l85.868-23.013,1.116,4.175-85.868,23.008Zm2.88,10.729,85.861-23.007,1.116,4.169-85.862,23.007Zm5.747,21.466,69.718-18.678,1.116,4.168-69.712,18.679Zm2.88,10.736,79.294-21.25,1.116,4.175-79.294,21.243Zm3.99,14.9-1.116-4.175,60.042-16.082,1.116,4.168Zm39.576,49.788-1.116-4.169,36.912-9.891,1.123,4.168Zm-48.2-81.989-1.116-4.169,85.868-23.007,1.116,4.168Z",
    transform: "translate(-90.09 -99.829)",
    fill: "#f60"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_345",
    "data-name": "Grupo 345",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_344",
    "data-name": "Grupo 344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_328",
    "data-name": "Grupo 328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_327",
    "data-name": "Grupo 327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2223",
    "data-name": "Caminho 2223",
    d: "M238.77,218.765l-2.855-10.656-16.989-63.4-1.153-4.317-1.825-6.8-1.153-4.316-1.825-6.8-1.153-4.316-3.767-14.059a21.182,21.182,0,0,0-.827-2.455,20.112,20.112,0,0,0-2.411-4.316,20.626,20.626,0,0,0-21.984-7.788l-29.068,7.788-16.187,4.341h-.019l-6.438,1.726-9.392,2.516L104.4,110.563a20.6,20.6,0,0,0-14.558,25.221l30.721,114.659a20.625,20.625,0,0,0,19.856,15.268A20.765,20.765,0,0,0,145.78,265l29.069-7.788,16.107-4.317,33.255-8.91a20.622,20.622,0,0,0,14.559-25.221ZM223.1,239.812,174.269,252.9l-16.107,4.317-13.5,3.619a16.274,16.274,0,0,1-19.93-11.513l-6.876-25.659L94.006,134.667a16.273,16.273,0,0,1,11.506-19.93L119,111.124l5.421-1.456,29.913-8.016,16.107-4.316,13.5-3.62a16.239,16.239,0,0,1,15.077,3.62,16.228,16.228,0,0,1,4.853,7.887l3.466,12.943,1.159,4.316,1.819,6.8,1.159,4.316,1.819,6.8,1.159,4.317,20.14,75.175A16.294,16.294,0,0,1,223.1,239.812Z",
    transform: "translate(-89.128 -88.845)",
    fill: "#161615",
    stroke: "#000",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_343",
    "data-name": "Grupo 343",
    transform: "translate(16.946 19.828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_330",
    "data-name": "Grupo 330",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    "data-name": "Grupo 329",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_407",
    "data-name": "Ret\\xE2ngulo 407",
    width: 88.894,
    height: 4.317,
    transform: "translate(0 23.016) rotate(-15.006)",
    fill: "#161615",
    stroke: "#000",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_332",
    "data-name": "Grupo 332",
    transform: "translate(2.876 10.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_331",
    "data-name": "Grupo 331",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_408",
    "data-name": "Ret\\xE2ngulo 408",
    width: 88.894,
    height: 4.317,
    transform: "translate(0 23.016) rotate(-15.006)",
    fill: "#161615",
    stroke: "#000",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_334",
    "data-name": "Grupo 334",
    transform: "translate(5.752 21.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_333",
    "data-name": "Grupo 333",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_409",
    "data-name": "Ret\\xE2ngulo 409",
    width: 88.894,
    height: 4.317,
    transform: "translate(0 23.016) rotate(-15.006)",
    fill: "#161615",
    stroke: "#000",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_336",
    "data-name": "Grupo 336",
    transform: "translate(8.628 36.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_335",
    "data-name": "Grupo 335",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_410",
    "data-name": "Ret\\xE2ngulo 410",
    width: 72.174,
    height: 4.317,
    transform: "translate(0 18.687) rotate(-15.006)",
    fill: "#161615",
    stroke: "#000",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_338",
    "data-name": "Grupo 338",
    transform: "translate(11.504 44.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_337",
    "data-name": "Grupo 337",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_411",
    "data-name": "Ret\\xE2ngulo 411",
    width: 82.092,
    height: 4.317,
    transform: "translate(0 21.255) rotate(-15.006)",
    fill: "#161615",
    stroke: "#000",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_340",
    "data-name": "Grupo 340",
    transform: "translate(14.379 60.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_339",
    "data-name": "Grupo 339",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_412",
    "data-name": "Ret\\xE2ngulo 412",
    width: 62.157,
    height: 4.317,
    transform: "translate(0 16.093) rotate(-15.006)",
    fill: "#161615",
    stroke: "#000",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_342",
    "data-name": "Grupo 342",
    transform: "translate(53.953 116.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_341",
    "data-name": "Grupo 341",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_413",
    "data-name": "Ret\\xE2ngulo 413",
    width: 38.219,
    height: 4.317,
    transform: "translate(0 9.895) rotate(-15.006)",
    fill: "#161615",
    stroke: "#000",
    strokeWidth: 1.5
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_350",
    "data-name": "Grupo 350",
    transform: "translate(90.135 48.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_347",
    "data-name": "Grupo 347",
    transform: "translate(0 1.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2224",
    "data-name": "Caminho 2224",
    d: "M219.712,224.7l64.569-64.569a1.817,1.817,0,0,1,1.588-.429,3.746,3.746,0,0,1,2.074,1.1l0,0,4.757,4.757,0,0a3.747,3.747,0,0,1,1.1,2.074,1.82,1.82,0,0,1-.429,1.589l-29.3,29.292-35.391,35.391a1.367,1.367,0,0,1-.359.263l-10.241,5.249a1.869,1.869,0,0,1-1.934-.487,2.107,2.107,0,0,1-.823-2.1l4.027-11.566A1.49,1.49,0,0,1,219.712,224.7Z",
    transform: "translate(-215.264 -159.671)",
    fill: "#f60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_349",
    "data-name": "Grupo 349",
    transform: "translate(3.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_348",
    "data-name": "Grupo 348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2225",
    "data-name": "Caminho 2225",
    d: "M226.071,243.5a5.413,5.413,0,0,1-3.526-1.411,5.243,5.243,0,0,1-1.755-5.617l4.026-11.566a4.734,4.734,0,0,1,1.121-1.8L290.5,158.543a5.052,5.052,0,0,1,4.341-1.347,7.012,7.012,0,0,1,3.913,2.024l4.756,4.756a7.014,7.014,0,0,1,2.023,3.912,5.046,5.046,0,0,1-1.347,4.342L239.506,236.91a4.634,4.634,0,0,1-1.169.855l-10.249,5.251A4.406,4.406,0,0,1,226.071,243.5Zm-.511-5.517a1.223,1.223,0,0,0,.46.471L236,233.34l64.592-64.589a1.811,1.811,0,0,0-.616-1.237l-4.76-4.76a1.8,1.8,0,0,0-1.237-.615L229.524,226.6Zm10.4-4.6,0,0Z",
    transform: "translate(-220.54 -157.137)",
    fill: "#161615",
    stroke: "#000",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutlined);
export default __webpack_public_path__ + "static/media/sign-outlined.46e349dcb5804415b1842a3f4a946dc1.svg";
export { ForwardRef as ReactComponent };